import { useContext } from 'react';
import { ApplicationAttributesContext } from '@developer/portal/context';

const useAddAppForm = () => {

  const {
    solutions,
    patientCategories,
    providerCategories,
    intendedUsers,
    intendedPurposes,
  }: any = useContext(ApplicationAttributesContext);

  const providerCategoryDropdownOptions = providerCategories?.map(
    (item: any) => ({
      label: item?.name,
      value: item.id,
    })
  );

  const patientCategoryDropdownOptions = patientCategories?.map(
    (item: any) => ({
      label: item?.name,
      value: item.id,
    })
  );

  const appProductsDropdownOptions = solutions?.map((item: any) => ({
    label: item?.name,
    value: item.id,
  }));
  

  const intendedUserDropdownOptions = intendedUsers?.map((item: any) => ({
    label: item?.name,
    value: item.id,
  }));

  const intendedPurposesDropdownOptions = intendedPurposes?.map((item: any) => ({
    label: item?.name,
    value: item.id,
  }));

  return {
    appProductsDropdownOptions,
    providerCategoryDropdownOptions,
    patientCategoryDropdownOptions,
    intendedUserDropdownOptions,
    intendedPurposesDropdownOptions
  };
};

export default useAddAppForm;
